/**
 * Sound Settings Page
 * Full page for configuring sound notification preferences
 */
import React from 'react';
import { Layout } from '../../components/Layout';
import { SoundSettings } from '../../components/settings/SoundSettings';

export function SoundsSettingsPage() {
  return (
    <Layout title="Sound Notifications">
      <div className="max-w-3xl mx-auto py-6 px-4">
        <SoundSettings />
      </div>
    </Layout>
  );
}

export default SoundsSettingsPage;
